// inital JS load
(($) => {

    // when document ready,
    document.addEventListener('DOMContentLoaded', () => {

        const $accordions = document.querySelectorAll('.accordion__btn');
        if ( !$accordions.length ) {
            return;
        }

        $accordions.forEach($e => $e.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const expanded = $e.parentNode.parentNode.getAttribute('data-open') == "true";
            $e.parentNode.parentNode.setAttribute('data-open', !expanded);
        }));

    }, false);

})(jQuery);